export default class IntegrationXeroAPIService {
  constructor(httpClient) {
    this.httpClient = httpClient
  }

  // Contacts
  getXeroContactList()                { return this.httpClient.get(`/integrations/xero/xeroContacts`) }
  getContactFromXero(xeroContactID)   { return this.httpClient.get(`/integrations/xero/xeroContacts/${xeroContactID}`) }
  relinkContact(contactId, data)      { return this.httpClient.post(`/integrations/xero/relink/contacts/${contactId}`, data) }

  // Config
  getConfig()                         { return this.httpClient.get(`/integrations/xero/config`) }
  getAccountConfigList()              { return this.httpClient.get(`/integrations/xero/accountconfigs`) }
  getTaxRateConfigList()              { return this.httpClient.get(`/integrations/xero/taxrateconfigs`) }
  updateConfig(data)                  { return this.httpClient.put(`/integrations/xero/config`, data) }

  getSyncErrorList()                  { return this.httpClient.get(`/integrations/xero/syncerrors`) }
  clearSyncErrorMessage(data)         { return this.httpClient.post(`/integrations/xero/syncerrors/clear`, data) }

  // Xero Data Access
  getXeroAccountList()                { return this.httpClient.get(`/integrations/xero/xeroaccounts`) }
  getXeroTaxRateList()                { return this.httpClient.get(`/integrations/xero/xerotaxrates`) }
  
}
